/**
 * 刊登模块路由
 */

//  import layout from '@/components/layout/Layout.vue'

// export default {
//   path: '/publish/listings',
//   name: '刊登',
//   component: (resolve) => require(['@/views/publish/listings/Index.vue'], resolve),
//   children: [
//     {
//       name: '/publish/listings',
//       path: '/publish/listings',
//       component: (resolve) => require(['@/views/publish/listings/Index.vue'], resolve)
//     },
//     {
//       name: '/publish/edit',
//       path: '/publish/edit',
//       component: (resolve) => require(['@/views/publish/edit/Index.vue'], resolve)
//     }
//   ]
// }

export default [
  {
    name: '刊登列表',
    path: '/publish/listings',
    component: (resolve) => require(['@/views/publish/listings/Index.vue'], resolve),
    meta: {
      pageId: 'publish_listings'
    }
  },
  {
    name: '刊登列表',
    path: '/publish/userDesign',
    component: (resolve) => require(['@/views/publish/userDesign/Index.vue'], resolve),
    meta: {
      pageId: 'publish_userDesign'
    }
  },
  {
    name: '单体刊登',
    path: '/publish/edit',
    component: (resolve) => require(['@/views/publish/edit/Index.vue'], resolve),
    meta: {
      pageId: 'publish_edit'
    }
  },
  {
    name: '心愿清单',
    path: '/publish/productList',
    component: (resolve) => require(['@/views/publish/productList/Index.vue'], resolve),
    meta: {
      pageId: 'publish_productList'
    }
  },
  {
    name: '任务队列列表',
    path: '/publish/batchTasks',
    component: (resolve) => require(['@/views/publish/batchTasks/Index.vue'], resolve),
    meta: {
      pageId: 'publish_batchTasks'
    }
  },
  {
    name: 'MT刊登详情',
    path: '/publish/MTDetail',
    component: (resolve) => require(['@/views/publish/listings/components/MTDetail.vue'], resolve),
    meta: {
      pageId: 'publish_MTDetail'
    }
  },
  {
    name: 'MT批量刊登',
    path: '/publish/batchPublish',
    component: (resolve) => require(['@/views/publish/productList/components/batchListToStoreModal.vue'], resolve),
    meta: {
      pageId: 'publish_batchPublish'
    }
  },
  {
    path: '/commodity/customProduct/list', // 定制列表
    component: resolve => require(['@/views/publish/customProduct/list/Index.vue'], resolve),
    meta: {
      pageId: 'publish_customProductList'
    }
  },
  {
    path: '/commodity/customProduct/add', // 定制添加
    // component: resolve => require(['@/views/publish/customProduct/detail/Index.vue'], resolve)
    component: resolve => require(['@/views/home/customized/addProduct.vue'], resolve),
    meta: {
      pageId: 'publish_customProductAdd'
    }
  },
  {
    path: '/commodity/customProduct/edit', // 定制编辑
    // component: resolve => require(['@/views/publish/customProduct/detail/Index.vue'], resolve)
    component: resolve => require(['@/views/home/customized/addProduct.vue'], resolve),
    meta: {
      pageId: 'publish_customProductEdit'
    }
  },
  {
    path: '/commodity/customProduct/detail', // 定制详情
    // component: resolve => require(['@/views/publish/customProduct/detail/Index.vue'], resolve)
    component: resolve => require(['@/views/home/customized/addProduct.vue'], resolve),
    meta: {
      pageId: 'publish_customProductDetail'
    }
  },
  {
    name: 'temu创建商品',
    path: '/publish/listings/temuCreate',
    component: (resolve) => require(['@/views/publish/listings/temuCreate.vue'], resolve),
    meta: {
      pageId: 'publish_temuCreate'
    }
  }
]

